module.exports = __webpack_public_path__ + "img/meike.dc216b1f.png";